<script lang="ts">
    import { onDestroy, onMount } from 'svelte';
    import Router from 'svelte-spa-router';

    import AdvRetentionDialog from '../components/AdvRetentionDialog.svelte';
    import { EXPOSE_FAIL_SW, EXPOSE_SUCCESS_SW } from '../enums/track';
    import routes from '../routers/cardRegular';
    import { regPageExposeAt } from '../store/index';
    import { handleAppLoginSuccess } from '../utils/appLoginSuccess';
    import { checkIsLogin } from '../utils/passport';
    import { prepareOmegaParams, trackEvent } from '../utils/track';

    import GlobalToast from '@/components/GlobalToast.svelte';
    import { reportP4Direct } from '@/utils/fmpTrack';
    import { showGlobalToast } from '@/utils/globalToast';
    import { attachOfflineToast } from '@/utils/offlineToast';
    import { trackEventModuleSw } from '@/utils/techTrack';

    let detachOfflineToast: (() => void) | undefined;

    onMount(() => {
        prepareOmegaParams();
        regPageExposeAt.set(Date.now());
        trackEvent(EXPOSE_SUCCESS_SW);
        reportP4Direct();
        trackEventModuleSw('main_page_sw');
        // 登录态异步旁路，不阻塞首屏曝光 / P4
        void checkIsLogin();

        detachOfflineToast = attachOfflineToast(showGlobalToast, () => {
            trackEvent(EXPOSE_FAIL_SW, {
                error_msg: 'page_offline_error',
                error_code: '1001'
            });
        });

        document.addEventListener('login', (event: Event) => {
            const customEvent = event as CustomEvent<{
                type: string;
                data: { ticket: string; cell: string; uid: string };
            }>;

            if (customEvent.detail?.type === 'success') {
                handleAppLoginSuccess(customEvent.detail.data);
            }
        });
    });

    onDestroy(() => {
        detachOfflineToast?.();
    });
</script>

<div class="app-card-regular">
    <Router {routes} />
    <AdvRetentionDialog />
    <GlobalToast />
</div>

<style lang="scss">
    .app-card-regular {
        width: 7.5rem;
        margin: auto;
        overflow-x: hidden;
    }
</style>
